import { Routes } from '@angular/router';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { AllUpdatesComponent } from './dashboard/claim-overview/all-updates/all-updates.component';
import { ClaimContactsComponent } from './dashboard/claim-overview/claim-contacts/claim-contacts.component';
import { ClaimOverviewComponent } from './dashboard/claim-overview/claim-overview.component';
import { IncidentDetailsComponent } from './dashboard/claim-overview/incident-details/incident-details.component';
import { PaymentsComponent } from './dashboard/claim-overview/payments/payments.component';
import { PAKClaimsListComponent } from './dashboard/pak-claims-list/pak-claims-list.component';
import { PolicyClaimsListComponent } from './dashboard/policy-claims-list/policy-claims-list.component';
import { FarmFlexDeductibleComponent } from './farm-flex-deductible/farm-flex-deductible.component';
import { FirstNoticeOfLossComponent } from './first-notice-of-loss/first-notice-of-loss.component';

export const claimsRoutes: Routes = [
    { path: 'claim-overview', component: ClaimOverviewComponent },
    { path: 'first-notice-of-loss', component: FirstNoticeOfLossComponent, data: { title: 'Start a Claim' } },
    { path: 'farm-flex-deductible', component: FarmFlexDeductibleComponent },
    { path: 'confirmation', component: ConfirmationComponent, data: { title: 'Start a Claim' } },
    { path: 'pak-claims-list', component: PAKClaimsListComponent },
    { path: 'policy-claims-list', component: PolicyClaimsListComponent },
    { path: 'claim-overview/all-updates', component: AllUpdatesComponent },
    { path: 'claim-overview/incident-details', component: IncidentDetailsComponent },
    { path: 'claim-overview/claim-contacts', component: ClaimContactsComponent },
    { path: 'claim-overview/payments', component: PaymentsComponent },
    { path: '', redirectTo: 'first-notice-of-loss', pathMatch: 'full' }
];

export const routedComponents = [
    FirstNoticeOfLossComponent,
    ConfirmationComponent,
    PAKClaimsListComponent,
    PolicyClaimsListComponent,
    ClaimOverviewComponent,
    FarmFlexDeductibleComponent
];
